<template>
    <main class="maim__page">
        <component 
            @show-record = "(e)=>{ this.$emit('showRecord',e)}"
            v-for = "item in skeleton" 
            :key="item.id" 
            :id="item.id" 
            :admin="admin"
            :typeTols="item.component_name"
            :is="item.component_name"
            :params="item.params"
            :header="item.header"
            :url="item.url"/> 
    </main>
</template>

<script>
import components from '@/mixins/components.mixin.js'
import axios from 'axios';
// import axios from 'axios';
export default{
    mixins:[components],
    mounted(){
        this.getSkeleton(this.$route.fullPath) 
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.admin = true
                } else {
                    this.admin = false
                }
            })
    },
    data(){
        return{
            admin:false
        }
    }
}
</script>

<style>
    main.maim__page{
        display: flex;
        flex-direction: column;
        gap: 64px;
    }
    .main{
        background-color:var(--background);
        padding-top: 40px;
        margin-top: 204px;
    }
    
    .offices__panel{
        display: grid;
        grid-template-columns:repeat(6,1fr); 
        gap: 32px;  
    }
    .offices__panel .panel{
        width: 100%;
        padding: 32px;
    }
    
    .appointment_info__panel{
        padding: 8px 32px 32px 32px;
    }
    .appointment_info__panel h3{
        font-size: 16px;
        margin:20px 0 10px 0;
    }
   
    main.maim__page section:last-child{
        padding-bottom: 114px
    }
    .close-btn {
        position: absolute;
        top: 30px;
        right: 30px;
        background-color: rgba(0,0,0,0);
        width: 16px;
        height: 16px;
        opacity: .8;
        z-index: 1;
        cursor: pointer;
        border-style: none;
        padding: 0;
    }
    @media (max-width: 1000px){
        .main{
            padding-top: 32px;
            margin-top: 76px;
        }
        main.maim__page section:last-child{
            padding-bottom: 0 !important
        }
        .maim__page section:last-child{
            padding-bottom: 80px
        }
    }

</style>